import {
  Box,
  Button,
  Flex,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
} from "@chakra-ui/react";
import { ChevronDownIcon } from "@chakra-ui/icons";
import React, { useEffect, useState } from "react";

const StatusDropdown = ({ statusOptions = [], initialStatus, color, changeHandler, isDisabled = false, }) => {
  // const defaultStatus = initialStatus || (statusOptions.length > 0 ? statusOptions[0].value : "");
  const [status, setStatus] = useState();

  const currentStatus = statusOptions.find((option) => option.value === status) || {};

  useEffect(() => {
    setStatus(initialStatus)
  }, [initialStatus])


  return (
    <Menu>
      <MenuButton
        className="selectBtn"
        as={Button}
        rightIcon={<ChevronDownIcon />}
        variant="outline"
        px={3}
        py={1}
        borderRadius="md"
        bg={color || "white"}
        overflow={"hidden"}
        w="150px"
        _hover={!isDisabled ? { borderColor: "gray.400" } : {}}
        isDisabled={isDisabled}
        cursor={isDisabled ? "not-allowed" : "pointer"}
      >
        <Flex align="center" gap={2}>
          {currentStatus.color && (
            <Box w="10px" minW={"10px"} h="10px" bg={currentStatus.color} borderRadius="full" />
          )}
          <Text fontWeight="bold" className="statusSelectedText" overflow={"hidden"}>{currentStatus.name || "Select Status"}</Text>
        </Flex>
      </MenuButton>

      {!isDisabled && (
        <MenuList maxHeight={"220px"} overflow={"auto"}>
          {statusOptions.map((option) => (
            <MenuItem
              key={option.value}
              onClick={() => {
                changeHandler(option.value)
                setStatus(option.value)
              }}
              _hover={{ bg: "gray.100" }}
            >
              <Flex align="center" gap={2}>
                <Box w="10px" minW={"10px"} h="10px" bg={option.color} borderRadius="full" />
                <Text className="statusText">{option.name}</Text>
              </Flex>
            </MenuItem>
          ))}
        </MenuList>
      )}
    </Menu>
  );
};


export default StatusDropdown;


